module.exports = __webpack_public_path__ + "img/objectCard.2894b95.png";